import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '@lib/services';
import { AngularMaterialModule } from 'src/app/material.module';
import { MatDialogRef } from '@angular/material/dialog';
import { CardLessService } from '@lib/services/card-less/card-less.service';
import { ApiResponseError, IAuthResponse } from '@lib/interfaces';
import { SpinnerComponent } from '../../../../lib/components/spinner/spinner.component';
import { BaseComponent } from '@lib/components';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-cash-out',
    templateUrl: './cash-out.component.html',
    styleUrls: ['./cash-out.component.scss'],
    standalone: true,
    imports: [AngularMaterialModule, SpinnerComponent],
    providers: [SidePanelService],
})
export class CashOutComponent extends BaseComponent implements OnInit {
    private userInfo: IAuthResponse['admin'] = JSON.parse(localStorage.getItem('userInfo') || '');
    qrUrl: string;
    loading = false;

    constructor(public dialogRef: MatDialogRef<CashOutComponent>, private sidePanelService: SidePanelService, private cardLessService: CardLessService, private snackBarService: MatSnackBar) {
        super();
    }

    ngOnInit() {
        this.generateQrCode();
    }

    onDownload() {
        const downloadLink = document.createElement('a');
        downloadLink.href = this.qrUrl;
        downloadLink.download = 'QR_Code.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    generateQrCode() {
        this.loading = true;

        this.cardLessService
            .qrGenerator(this.userInfo.id)
            .pipe(
                catchError((error: ApiResponseError) => {
                    this.createApiErrorSnackBar(this.snackBarService, error);
                    return of(null);
                }),
            )
            .subscribe((img) => {
                if (img) {
                    this.qrUrl = URL.createObjectURL(img);
                }
                this.loading = false;
            });
    }
}
